<p-toast [life]="10000" [key]="ToastPositionKeys.TOP_CENTER" position="top-center"></p-toast>
<p-toast [life]="5000" [key]="ToastPositionKeys.TOP_RIGHT" position="top-right"></p-toast>
<p-toast [life]="10000" [key]="ToastPositionKeys.BOTTOM_CENTER" position="bottom-center"></p-toast>
<p-toast [life]="5000" [key]="ToastPositionKeys.BOTTOM_RIGHT" position="bottom-right"></p-toast>
<router-outlet></router-outlet>
<p-confirmDialog />
